<template>
  <div class="modal fade" :id="option.id" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{option.title}}</h4>
        </div>
        <div class="modal-body">
          <slot name="body">
            <p v-html="option.body"></p>
            <div class="box-body form p-x-0" v-if="selectOptions || option.input">
              <!-- select -->
              <div class="input-group" v-if="selectOptions">
              <span class="input-group-addon">
                {{selectOptions.name}}
              </span>
                <div class="form-group m-0">
                  <select class="form-control h-38" v-model="selected" @change="selectOnChange">
                    <option v-for="option in selectOptions.options" :value="option.value">
                      {{option.text}} <span v-if="option.value !== null">({{option.value}})</span>
                    </option>
                  </select>
                </div>
              </div>
              <!-- End select -->

              <!-- input -->
              <div v-if="option.input">
                <br>
                <div class="input-group">
                  <span class="input-group-addon">{{option.input.name}}</span>
                  <input class="form-control" placeholder="" type="text" v-model="inputValue" @change="inputOnChange(inputValue)">
                </div>
                <br />
              </div>
              <!-- End input -->
            </div>
          </slot>
        </div>
        <div class="modal-footer" :style="{'text-align': option.footerTextAlign || 'right'}">
          <button type="button" class="btn btn-default" v-for="btn in option.btns" @click="trigger(btn.event)" data-dismiss="modal">{{btn.name}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'nd-modal',
  props: {
    option: {
      type: Object,
      required: true
    },
    selectOptions: {
      type: Object
    },
    selectDefault: {
      type: [String, Number]
    },
    selectChange: {
      type: [String, Number]
    }
  },
  data () {
    return {
      selected: 0,
      inputValue: ''
    }
  },
  methods: {
    trigger (event) {
      this.$emit('trigger', event)
    },
    selectOnChange () {
      this.$emit('selectOnChange', this.selected)
    },
    inputOnChange () {
      this.$emit('inputOnChange', this.inputValue)
    }
  },
  created () {
    if (this.selectOptions) {
      for (var i = 0; i < this.selectOptions.options.length; i++) {
        if (i === 0 && !this.selectDefault) this.selected = this.selectOptions.options[i].value
        else if (this.selectDefault) {
          this.selected = parseInt(this.selectDefault, 10)
          break
        }
      }
    }
  },
  watch: {
    /*
    selectDefault () {
      this.selected = parseInt(this.selectDefault, 10)
    }
    */
    selectChange () {
      this.selected = parseInt(this.selectChange, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Modal.vue?9aa34654